import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=46b66268&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b66268')) {
      api.createRecord('46b66268', component.options)
    } else {
      api.reload('46b66268', component.options)
    }
    module.hot.accept("./channel.vue?vue&type=template&id=46b66268&", function () {
      api.rerender('46b66268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/channel.vue"
export default component.exports